import type { VariantProps } from "class-variance-authority"
import { cva } from "class-variance-authority"

export { default as Button } from "./Button.vue"

export const buttonVariants = cva(
  "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-all disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 shrink-0 [&_svg]:shrink-0 outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive",
  {
    variants: {
      variant: {
        default:
          "bg-primary text-primary-foreground hover:bg-primary/90",
        destructive:
          "bg-destructive text-white hover:bg-destructive/90 focus-visible:ring-destructive/20 dark:focus-visible:ring-destructive/40 dark:bg-destructive/60",
        outline:
          "border bg-background shadow-xs hover:bg-accent hover:text-accent-foreground dark:bg-input/30 dark:border-input dark:hover:bg-input/50",
        secondary:
          "bg-secondary text-secondary-foreground hover:bg-secondary/80",
        ghost:
          "hover:bg-accent hover:text-accent-foreground dark:hover:bg-accent/50",
        link: "text-primary underline-offset-4 hover:underline",
        ['ghost-destructive']: "hover:bg-destructive/10 hover:text-destructive focus-visible:ring-destructive/20 dark:focus-visible:ring-destructive/40",
        ['outline-destructive']: "border border-destructive text-destructive hover:bg-destructive/10 focus-visible:ring-destructive/20 dark:focus-visible:ring-destructive/40",
        // Companion / AI-assistant styling (purple). Used by the playground,
        // the topic assistant and anything else driven by the AI companion.
        assistant:
          "border border-assistant-500 bg-background text-assistant-500 shadow-xs hover:bg-assistant-500 hover:text-white focus-visible:ring-assistant-500/20",
        ['assistant-filled']:
          "border border-assistant-500 bg-assistant-500 text-white hover:bg-assistant-600 hover:border-assistant-600 focus-visible:ring-assistant-500/20",
        // Same as `assistant` but with an animated sweep, for "the AI is working" states.
        ['assistant-loading']:
          "relative overflow-hidden border border-assistant-500 bg-background text-assistant-500 moin-btn-sweep",
        // Admin-only actions, visible to moinAI staff (pink).
        admin:
          "bg-admin-500 text-white hover:bg-admin-600 focus-visible:ring-admin-500/20",
        ['admin-outline']:
          "border border-admin-500 bg-background text-admin-500 shadow-xs hover:bg-admin-500 hover:text-white focus-visible:ring-admin-500/20",
      },
      size: {
        "default": "h-9 px-4 py-2 has-[>svg]:px-3",
        "sm": "h-8 rounded-md gap-1.5 px-3 has-[>svg]:px-2.5",
        "lg": "h-10 rounded-md px-6 has-[>svg]:px-4",
        "icon": "size-9",
        "icon-sm": "size-8",
        "icon-lg": "size-10",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  },
)
export type ButtonVariants = VariantProps<typeof buttonVariants>
